import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "../lib/utils";

const alertVariants = cva("rounded border px-3 py-2 text-sm", {
  variants: {
    variant: {
      info: "border-border bg-muted/30 text-foreground",
      warning: "border-warning/30 bg-warning/10 text-foreground",
      destructive: "border-destructive/30 bg-destructive/10 text-foreground",
      success: "border-success/30 bg-success/10 text-foreground",
    },
  },
  defaultVariants: {
    variant: "info",
  },
});

interface AlertProps
  extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof alertVariants> {
  children: React.ReactNode;
}

function Alert({ variant, className, children, role = "status", ...props }: AlertProps) {
  return (
    <div className={cn(alertVariants({ variant }), className)} role={role} {...props}>
      {children}
    </div>
  );
}

export { Alert, alertVariants };
export type { AlertProps };
